import React from "react";
import UserMyTicketsPage from "modules/support/my-tickets/flow/userTickets/page";

const MyTicketsPage = () => {
    return <UserMyTicketsPage />;
};

export default MyTicketsPage;
